import Markdown from '../Markdown'

/** @param {{ content?: string, streaming?: boolean }} props */
export default function StepNarration({ content = '', streaming = false }) {
  if (streaming) {
    return <Markdown streaming>{content}</Markdown>
  }

  if (!content.trim()) return null

  return <Markdown>{content}</Markdown>
}
